import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import About from "./Pages/About";
import ForgetPassword from "./Pages/Auth/ForgetPassword";
import Home from "./Pages/Home";
import Imr from "./Pages/Imr";
import ImrList from "./Pages/ImrList";
import IsrList from "./Pages/IsrList";

import Isr from "./Pages/Isr";
import Login from "./Pages/Auth/Login";
import MoreProducts from "./Pages/MoreProducts";
import Recent from "./Pages/Recent";
import Saved from "./Pages/Saved";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TermsCondition from "./Pages/TermsCondition";
import OTP from "./Pages/Auth/Otp";
import PasswordResetSuccessfull from "./Pages/Auth/PasswordResetSuccessfull";
import ChangePassword from "./Pages/Auth/ChangePassword";
import CreateNewPassword from "./Pages/Auth/CreateNewPassword";
import ViewImr from "./Pages/ViewImr";
import ViewIsr from "./Pages/ViewIsr";
import PageNotFound from "./Pages/PageNotFound";
import noInternet from "./assets/images/noInternet.svg";
import secureLocalStorage from "react-secure-storage";
import { Profile } from "./Pages/Profile/Profile";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const accessToken = secureLocalStorage.getItem("token");

  const notify = (message, type) => {
    type == "success"
      ? toast.success(message, {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
      : toast.error(message, {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",

          style: {
            backgroundColor: "#D92533",
          },
        });
  };

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      notify("Welcome back! You are now online.", "success");
    };
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOnline) {
    return (
      <div style={{ height: "100vh", padding: "20px" }} className="text-center">
        <div>
          <img
            className="noDataImg"
            width={600}
            src={noInternet}
            alt="nodata"
          />
        </div>
        <h1>No internet connection</h1>
        <p>Please check your internet connection and try again.</p>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/recent" element={<Recent />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/createimr" element={<Imr />} />
          <Route path="/createisr" element={<Isr />} />
          <Route path="/view-imr" element={<ViewImr />} />
          <Route path="/view-isr" element={<ViewIsr />} />
          <Route path="/imr-list" element={<ImrList />} />
          <Route path="/isr-list" element={<IsrList />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/otp" element={<OTP />} />
          <Route path="/success" element={<PasswordResetSuccessfull />} />
          <Route path="/more-products" element={<MoreProducts />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/create-new-password" element={<CreateNewPassword />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
